module.exports = __webpack_public_path__ + "img/skull_bj.97e163b2.png";